import { get } from "lodash";

export default function setupAxios(axios, store) {
  /**
   * REQUEST INTERCEPTORS
   * Capture and modify all the outgoing request
   */
  axios.interceptors.request.use(
    (request) => {
      const { auth } = store.getState();
      const idToken = get(auth, "data.idToken");

      if (idToken) {
        request.headers.Authorization = `Bearer ${idToken}`;
      }

      return request;
    },
    (err) => Promise.reject(err)
  );

  /**
   * RESPONSE INTERCEPTORS
   * Capture and modify all the incoming response
   */
  axios.interceptors.response.use(
    function (response) {
      return response.data || response;
    },
    function (error) {
      // if ([401, 403].includes(get(error, "response.status"))) {
      //   localStorage.clear();
      //   window.location.replace(ROUTE_SIGNIN);
      // }
      return Promise.reject(
        error.response ? error.response.data || error.response : error
      );
    }
  );
}
